export enum GameMode {
    CLASSIC = "classic",
    TIMED = "timed", 
    FIGHT = "fight",
    ENDLESS = "endless",
    FLASH = "flash",
    HAZARD = "hazard",
    COOP = "coop",
    DAILY = "daily",
    CUSTOM = "custom"
}

export enum GameModeStatus {
    AVAILABLE = "available",
    COMING_SOON = "coming_soon",
    LOCKED = "locked"
}

export interface GameModeConfig {
    mode: GameMode;
    name: string;
    maxRounds: number;
    timerSeconds: number | null; // null means no timer
    hasSpecialRules: boolean;
    status: GameModeStatus;
    minPlayers: number;
    maxPlayers: number;
}

// Game mode hazards for Hazard mode
export enum GameHazard {
    PETRIFY = "petrify",
    SUBTRACTIVE_PALLETTE = "subtractive_palette",
    SKYBLIND = "skyblind",
    BLIND = "blind",
    SLEEP = "sleep",
    REVERSE = "reverse",
    FORCED_MARCH = "forced_march",
    MINI = "mini",
    TOAD = "toad",
    HASTE = "haste",
    CHARMED = "charmed",
    PIXELATE = "pixelate",
    MASCOT = "mascot",
}

export interface HazardConfig {
    hazards: GameHazard[];
    randomHazards: boolean;
    hazardIntensity: number; // 0-1 scale
}

// Extended config for modes with special requirements
export interface ExtendedGameModeConfig extends GameModeConfig {
    hazardConfig?: HazardConfig; // For Hazard mode
    flashDuration?: number; // For Flash mode (in milliseconds)
    dailySeed?: string; // For Daily mode
    damageMultiplier?: number; // For Fight mode
}